import {mapState} from "vuex";
import {LevelClass} from "@/mixins/level";

export default {
    data :{
        SUPER_ROLE:"ROLE_SUPER",
        NORMAL_ROLE :"ROLE_NORMAL"
    },
    computed: {
        ...mapState({
            UserInfo: state => state.userInfo.UserInfo,
        })
    },
    methods: {
        getAdminType() {
            let levelClass = new LevelClass();
            let level  = levelClass.getterLevel();
            
            return level;
        }
    },
}
